import http from '@/libs/http'

export default {
  find(id) {
    return http.get(`/cms/api/${id}`).then(result => result.data.result)
  },
  findAll(options) {
    const limit = 10
    const params = Object.assign({
      limit,
      offset: (options.page - 1) * limit,
      sortBy: 'id',
      order: 'desc'
    }, options)
    return http.get('/cms/apis', { params }).then(result => result.data)
  },
  create(model) {
    return http.post('/cms/apis', model).then(result => result.data)
  },
  update(model) {
    return http.put(`/cms/api/${model.id}`, this._clean(model)).then(result => result.data)
  },
  delete(id) {
    return http.delete(`/cms/api/${id}`).then(result => result.data)
  },
  preview(model) {
    return http.post('/cms/api/preview', model).then(result => result.data).catch(err => err.response.data)
  },
  play(id, options) {
    const params = Object.assign({}, options)
    return http.get(`/cms/api/play/${id}`, { params }).then(result => result.data)
  },
  clearCache(id) {
    return http.post(`/cms/api/clear-cache/${id}`).then(result => result.data)
  },
  rollback(id) {
    return http.get(`/cms/api/rollback/${id}`).then(result => result.data)
  },
  _clean(model) {
    const m = Object.assign({}, model)
    delete m.id
    return m
  },
  checkApiAlias(aliasPayload) {
    const payload = typeof aliasPayload === 'object' && aliasPayload !== null
      ? aliasPayload
      : { alias: aliasPayload }
    return http.post(`/cms/api/check-alias`, payload).then(result => result.data.result)
  }
}
